export const GLOBAL_EVENT = {
  PAGE_INIT: 'PAGE_INIT',
  SHOW_CHAT_CONTENT: 'SHOW_CHAT_CONTENT',
  TABLE_ITEM_CLICK: 'TABLE_ITEM_CLICK',
  MENU_ITEM_CLICK: 'MENU_ITEM_CLICK',
  FILTER_ITEM_CHANGED: 'FILTER_ITEM_CHANGED',
  OPEN_BUTTON_TRIGGER_MODAL: 'OPEN_BUTTON_TRIGGER_MODAL',
  CLOSE_BUTTON_TRIGGER_MODAL: 'CLOSE_BUTTON_TRIGGER_MODAL',
  CHART_ITEM_CLICK: 'CHART_ITEM_CLICK',
  DATA_SORT: 'DATA_SORT',
  SORT_CHANGE: 'SORT_CHANGE',
  CONDITION_CHANGE: 'CONDITION_CHANGE',
};
